<template>
  <div class="main-wrapper money-exchange">
    <div class="container">
      <div class="invoice-wrapper download_section">
        <div class="inv-content">
          <div class="invoice-header">
            <div class="inv-header-left">
              <a href="javascript:;">
                <img src="@/assets/img/logo2.png" alt="Logo" />
              </a>
              <div class="inv-details">
                <div class="inv-date">Date: <span>5/12/2022</span></div>
                <div class="inv-date mb-0">Invoice No: <span>INV 00001</span></div>
              </div>
            </div>
            <div class="inv-header-right">
              <div class="invoice-title tax-invoice">TAX INVOICE</div>
              <div class="cineplux-title">Money Exchange</div>
              <div class="company-details">
                <span class="company-name invoice-title">Dreamguys Banking</span>
                <div class="gst-details">
                  Address:
                  <span>15 Hodges Mews, High Wycombe HP12 3JL, United Kingdom.</span>
                </div>
              </div>
            </div>
          </div>
          <div class="exchange-details">
            <h4>Exchange Confirmation</h4>
            <div class="exchange-info">
              <div>Funded <span>Apr 25, 2022</span></div>
              <div>Paid Out <span>Apr 25, 2022</span></div>
              <div>Transfer ID <span>#12345</span></div>
              <div>Membership <span>VH456512BB</span></div>
            </div>
          </div>
          <div class="exchange-details transfer-overview">
            <h4>Transfer Overview</h4>
            <div class="exchange-info transfer-rate">
              <div>Ammount paid by Johan Smith <span>$8000 USD</span></div>
              <div>Abbount converted <span>$22771.17 CAD</span></div>
              <div>Converted and send to <span>$22,753.46 CAD</span></div>
            </div>
            <div class="exchange-info exchange-rate">
              <div>Fee <span>$8000 USD</span></div>
              <div>Exchange Rate <span>$1 USD = $ 1.27 CAD</span></div>
            </div>
          </div>
          <div class="exchange-details sendto">
            <h4>Send To</h4>
            <div class="sendto-details">
              <div class="sendto-left">
                <div>Name: <span>Vector john</span></div>
                <div>Bank Name & Branch: <span>Toronto Bank</span></div>
                <div>SWIFT / BIC Code: <span>MSV24678665RT</span></div>
                <div>Account Number: <span>2465789456324</span></div>
              </div>
              <div class="sendto-right">
                <div>Address: <span>2 Roanoke Road, Ontario, Canada</span></div>
                <div>Account Name: <span>Johan Smith </span></div>
                <div>Reference: <span>2465789456324</span></div>
              </div>
            </div>
          </div>
          <div class="exchange-details sendto">
            <h4>Paid Out From</h4>
            <div class="sendto-details">
              <div class="sendto-left">
                <div>Name: <span>Canadian Bank</span></div>
                <div>Reference: <span>SM2455452114545</span></div>
              </div>
              <div class="sendto-right">
                <div>Delivered: <span>Bank Transfer</span></div>
                <div>Account Name: <span>Johan Smith </span></div>
              </div>
            </div>
          </div>
          <div class="exchange-details exchange-notes">
            <h4>Notes</h4>
            <p>
              Your use of the Website shall be deemed to constitute your understanding and
              approval of, and agreementto be bound by, the Privacy Policy and you consent
              to the collection.
            </p>
          </div>
          <div class="thanks-msg text-center">Thanks for your Business</div>
        </div>
      </div>
      <div class="file-link">
        <button class="download_btn download-link">
          <i class="feather-download-cloud me-1"></i> <span>Download</span>
        </button>
        <a href="javascript:window.print()" class="print-link">
          <i class="feather-printer"></i> <span class="">Print</span>
        </a>
      </div>
    </div>
  </div>
</template>
